import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';
import { _Array } from './email-marketing-v1-campaign-campaigns.types';

function resolveWixEmailmarketingApiV1CampaignStatisticsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
      {
        srcPath: '/_api/shoutout/v1/automation/campaign',
        destPath: '/v1/automation/campaign',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/shoutout-editor/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/shoutout-editor/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/shoutout-editor/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    _: [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
      {
        srcPath: '/email-marketing/v1/identify-sender-address',
        destPath: '/v1/identify-sender-address',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/email-marketing/v1/campaigns',
        destPath: '/v1/campaigns',
      },
      {
        srcPath: '/email-marketing/v1/identify-sender-address',
        destPath: '/v1/identify-sender-address',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'shoutout._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/email-marketing/v1/campaigns',
        destPath: '/v1/campaigns',
      },
      {
        srcPath: '/email-marketing/v1/identify-sender-address',
        destPath: '/v1/identify-sender-address',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveWixEmailmarketingApiV1CampaignValidationServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/email-marketing/v1/campaign-validation',
        destPath: '/v1/campaign-validation',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaign-validation',
        destPath: '/v1/campaign-validation',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/email-marketing/v1/campaign-validation/validate-html-links',
        destPath: '/v1/campaign-validation/validate-html-links',
      },
      {
        srcPath: '/email-marketing/v1/campaign-validation/validate-link',
        destPath: '/v1/campaign-validation/validate-link',
      },
    ],
    _: [
      {
        srcPath: '/email-marketing/v1/campaign-validation/validate-html-links',
        destPath: '/v1/campaign-validation/validate-html-links',
      },
      {
        srcPath: '/email-marketing/v1/campaign-validation/validate-link',
        destPath: '/v1/campaign-validation/validate-link',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveWixEmailmarketingApiV1CampaignServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
      {
        srcPath: '/_api/shoutout/v1/automation/campaign',
        destPath: '/v1/automation/campaign',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/shoutout-editor/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/shoutout-editor/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/shoutout-editor/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    _: [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
      {
        srcPath: '/email-marketing/v1/identify-sender-address',
        destPath: '/v1/identify-sender-address',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/email-marketing/v1/campaigns',
        destPath: '/v1/campaigns',
      },
      {
        srcPath: '/email-marketing/v1/identify-sender-address',
        destPath: '/v1/identify-sender-address',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    'shoutout._base_domain_': [
      {
        srcPath: '/_api/shoutout/v1/campaigns',
        destPath: '/v1/campaigns',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/email-marketing/v1/campaigns',
        destPath: '/v1/campaigns',
      },
      {
        srcPath: '/email-marketing/v1/identify-sender-address',
        destPath: '/v1/identify-sender-address',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_email-marketing_campaigns';

/** Retrieves information about an email campaign. */
export function get(payload: object): RequestOptionsFactory<any> {
  function __get({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'GET' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService.Get',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'campaign.dateCreated' },
              { path: 'campaign.dateUpdated' },
              { path: 'campaign.dateScheduled' },
              { path: 'campaign.publishingData.datePublished' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __get;
}

/**
 * Retrieves a list of email campaigns.
 *
 * Default sorts by `dateUpdated` in `DESC` order.
 */
export function list(payload: object): RequestOptionsFactory<any> {
  function __list({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'datePublishedFrom' }, { path: 'datePublishedTo' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'GET' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService.List',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns',
        data: serializedData,
        host,
      }),
      params: toURLSearchParams(serializedData),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'campaigns.dateCreated' },
              { path: 'campaigns.dateUpdated' },
              { path: 'campaigns.dateScheduled' },
              { path: 'campaigns.publishingData.datePublished' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __list;
}

/**
 * Publishes and sends a specified campaign.
 *
 * If the `email_distribution_options` object isn't passed in the request, the campaign is only published as a landing page.
 */
export function publish(payload: object): RequestOptionsFactory<any> {
  function __publish({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'emailDistributionOptions.sendAt' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService.Publish',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}/publish',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'publishingData.datePublished' }],
          },
        ]),
    };

    return metadata;
  }

  return __publish;
}

/**
 * Sends a test email. Call this method to preview your email campaign.
 *
 * We strongly recommend calling this method only a few times in a row, as there is a rate limit to prevent abuse of the Send Test method.
 */
export function sendTest(payload: object): RequestOptionsFactory<any> {
  function __sendTest({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'placeholders.*.dateTime.timestamp' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService.SendTest',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}/test',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __sendTest;
}

/** Pauses a scheduled campaign. */
export function pauseScheduling(payload: object): RequestOptionsFactory<any> {
  function __pauseScheduling({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService.PauseScheduling',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}/pause-scheduling',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __pauseScheduling;
}

/** Changes the sending time for an already scheduled campaign. */
export function reschedule(payload: object): RequestOptionsFactory<any> {
  function __reschedule({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [{ path: 'sendAt' }],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService.Reschedule',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}/reschedule',
        data: serializedData,
        host,
      }),
      data: serializedData,
    };

    return metadata;
  }

  return __reschedule;
}

/** Permanently deletes a campaign. */
export function _delete(payload: object): RequestOptionsFactory<any> {
  function ___delete({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'DELETE' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService._delete',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return ___delete;
}

/** Creates a copy of an existing campaign. */
export function reuse(payload: object): RequestOptionsFactory<any> {
  function __reuse({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService.Reuse',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}/reuse',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'campaign.dateCreated' },
              { path: 'campaign.dateUpdated' },
              { path: 'campaign.dateScheduled' },
              { path: 'campaign.publishingData.datePublished' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __reuse;
}

/** Retrieves the audience of a paused campaign. Use this method to retrieve all selected audience of the paused campaign at once, so they can be passed in bulk when the campaign is published again after being paused. */
export function getAudience(payload: object): RequestOptionsFactory<any> {
  function __getAudience({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn: 'wix.emailmarketing.api.v1.CampaignService.GetAudience',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}/audience',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __getAudience;
}

/** Checks if the sender's email address will be used as the "from" address or will it be replaced and to what exactly. */
export function identifySenderAddress(
  payload: object
): RequestOptionsFactory<any> {
  function __identifySenderAddress({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn:
        'wix.emailmarketing.api.v1.CampaignService.IdentifySenderAddress',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignServiceUrl({
        protoPath: '/v1/identify-sender-address',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __identifySenderAddress;
}

/**
 * Validates any provided link. Call this method when you want to check whether the link complies with the abuse rules and can be used in a campaign.
 *
 * If you provide a link as a placeholder, it's returned in a response as valid.
 */
export function validateLink(payload: object): RequestOptionsFactory<any> {
  function __validateLink({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn:
        'wix.emailmarketing.api.v1.CampaignValidationService.ValidateLink',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignValidationServiceUrl({
        protoPath: '/v1/campaign-validation/validate-link',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __validateLink;
}

/** Validates links that are inside the provided HTML. This method automatically takes out links from the HTML block and validates them. Call this method when you want to check whether the link complies with the abuse rules and can be used in a campaign. */
export function validateHtmlLinks(payload: object): RequestOptionsFactory<any> {
  function __validateHtmlLinks({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'POST' as any,
      methodFqn:
        'wix.emailmarketing.api.v1.CampaignValidationService.ValidateHtmlLinks',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignValidationServiceUrl({
        protoPath: '/v1/campaign-validation/validate-html-links',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __validateHtmlLinks;
}

/**
 * Retrieves a list of statistics for up to 100 selected campaigns.
 *
 * For each campaign, you receive the total activity count for the campaign's landing page and email. For example, the total
 * amount of times the landing page was opened, or the total amount of email recipients that clicked a link in an email.
 *
 * Call List Campaigns to retrieve additional information for a site's campaigns.
 * Call List Recipients to retrieve a list of recipients and their activities related to a selected campaign.
 */
export function listStatistics(payload: object): RequestOptionsFactory<any> {
  function __listStatistics({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'GET' as any,
      methodFqn:
        'wix.emailmarketing.api.v1.CampaignStatisticsService.ListStatistics',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignStatisticsServiceUrl({
        protoPath: '/v1/campaigns/statistics',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __listStatistics;
}

/**
 * Retrieves a list of recipients for a selected campaign based on a specific recipient activity.
 *
 * Pages are returned with a maximum of 1,000 recipients per page and defaults to 40 recipients per page.
 *
 * Call List Statistics to retrieve a list of activity for selected campaigns.
 * Call List Campaigns to retrieve additional information for your campaigns.
 *
 * If no `activity` is included, this method returns an error.
 */
export function listRecipients(payload: object): RequestOptionsFactory<any> {
  function __listRecipients({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.email_marketing.v1.campaign',
      method: 'GET' as any,
      methodFqn:
        'wix.emailmarketing.api.v1.CampaignStatisticsService.ListRecipients',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEmailmarketingApiV1CampaignStatisticsServiceUrl({
        protoPath: '/v1/campaigns/{campaignId}/statistics/recipients',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [{ path: 'recipients.lastActivityDate' }],
          },
        ]),
    };

    return metadata;
  }

  return __listRecipients;
}
